import { render, staticRenderFns } from "./embedded.vue?vue&type=template&id=41c9fca0&scoped=true&"
import script from "./embedded.vue?vue&type=script&lang=ts&"
export * from "./embedded.vue?vue&type=script&lang=ts&"
import style0 from "./embedded.vue?vue&type=style&index=0&id=41c9fca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c9fca0",
  null
  
)

export default component.exports